import React, { useState, useEffect } from 'react';

import { identifyVisitorId } from 'analytics/utils';
import GlobalLoader from 'components/GlobalLoader';
import Navigator from 'containers/Navigator';
import ScreenSizeContext from 'contexts/ScreenSize';
import { isDesktopSize, isMobileSize } from 'contexts/ScreenSize/utils';
import { useUpdateUserAttributesMutation } from 'graphql/mutations/customers/updateUserAttributes/mutation';
import { useAddInternalCaseTagsMutation } from 'graphql/mutations/lifeApplications/addInternalCaseTags/mutation';
import { useQueryParams } from 'hooks/useQueryParams';
import useSelector from 'store/useSelector';

const App: React.FC = () => {
  const [screenSize, setScreenSize] = useState({
    isDesktop: isDesktopSize(),
    isMobile: isMobileSize(),
  });
  const activeUserUuid = useSelector((app) => app.activeUserUuid);
  const activeLifeApplicationId = useSelector((app) => app.activeLifeApplicationId);
  const appLoading = useSelector((app) => app.loading);
  const params = useQueryParams();
  const [updateUserAttributes] = useUpdateUserAttributesMutation();
  const [addTags] = useAddInternalCaseTagsMutation();

  useEffect(() => {
    window.scrollTo(0, 0);

    window.addEventListener('resize', () => {
      setScreenSize({
        isDesktop: isDesktopSize(),
        isMobile: isMobileSize(),
      });
    });

    identifyVisitorId(activeUserUuid);

    if (params.get('show_prices') === 'true') {
      updateUserAttributes({
        variables: {
          input: {
            key: 'life_show_prices',
            uuid: activeUserUuid,
            value_json: JSON.stringify(true),
          },
        },
      });
    }

    if (params.get('dss_re_engage') === 'true') {
      addTags({
        variables: {
          input: {
            application_id: activeLifeApplicationId,
            internal_case_tags: ['DSS Re-engaged'],
          },
        },
      });
    }
  }, []);

  return (
    <ScreenSizeContext.Provider value={screenSize}>
      {appLoading && <GlobalLoader />}
      <Navigator />
    </ScreenSizeContext.Provider>
  );
};

export default App;
